import React, { FC } from 'react';
import { Chip } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { RowCard } from '@/components/RowCard';
import { useGetUserContractFund } from '../hooks/useGetUserContractFund';
import { HeaderButton } from './HeaderButton';

export const Header: FC = () => {
  const { hasUserContractFund } = useGetUserContractFund({ enabled: false });

  return (
    <RowCard
      chevronIconProps={{
        size: 24,
        className: 'text-gray-filled-tertiary-enabled',
      }}
      classNames={{
        root: '!px-0 !py-0 hover:!bg-transparent',
        title: '!text-sm !font-medium !text-gray-filled-primary-enabled',
        description:
          '!text-xxs !font-regular !text-gray-filled-tertiary-enabled',
      }}
      imageComponent={
        // TODO: the color must fix in figma design
        <Icon className="text-[#2FC4FF]" icon="refresh" size={32} />
      }
      secondTitle={<HeaderButton />}
      title={
        <div className="flex items-center justify-start gap-2">
          سرمایه‌گذاری مستمر
          {hasUserContractFund ? (
            <Chip variant="success">فعال</Chip>
          ) : (
            <Chip variant="error">غیرفعال</Chip>
          )}
        </div>
      }
      showIconOnClick
    />
  );
};
